import ruleConditionReducer from "./reducers";

export default ruleConditionReducer;